
import { UserProfile } from "@/types/profile";
import { UseFormRegister } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface SocialLinksFormProps {
  register: UseFormRegister<UserProfile>;
}

export const SocialLinksForm = ({ register }: SocialLinksFormProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Social Media Links</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="instagram">Instagram</Label>
          <Input
            id="instagram"
            {...register("social_links.instagram")}
            placeholder="@username"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="tiktok">TikTok</Label>
          <Input
            id="tiktok"
            {...register("social_links.tiktok")}
            placeholder="@username"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="twitter">Twitter</Label>
          <Input
            id="twitter"
            {...register("social_links.twitter")}
            placeholder="@username"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="facebook">Facebook</Label>
          <Input
            id="facebook"
            {...register("social_links.facebook")}
            placeholder="username or page URL"
          />
        </div>
      </CardContent>
    </Card>
  );
};
